module.exports = __webpack_public_path__ + "assets/est-24.0f1110bc86b00be197761df8cae6fab7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/est-24.png
 ** module id = 486
 ** module chunks = 0
 **/